import { BoldTextButton } from "thrive-components";
import { getModeratedCommentTitle } from "../notificationTitles.service";


export interface IModeratedCommentTitle {
    content: {
        id: number;
        title: string;
        link: string;
        isArchived: boolean;
        existsInMultiplePlaces: boolean;
    };
    commentAuthor: string;
    userWhoFlagged: string;      
    isPopOut?: boolean
}

const ModeratedCommentTitle = ({content, commentAuthor, userWhoFlagged, isPopOut}: IModeratedCommentTitle ) => {
    const {className, activityInformation, contentLinkAriaLabel, contentLink, contentLinkTitle} = getModeratedCommentTitle({content, commentAuthor, userWhoFlagged, isPopOut})
    
    return (
        <span className={className}>
            {activityInformation.part1}

            <BoldTextButton
                ariaLabel={contentLinkAriaLabel}
                link={contentLink}
                text={contentLinkTitle}
            />

            {activityInformation.part2}
        </span>
    );
};
export default ModeratedCommentTitle;
